import React from "react"

import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../../render/table/table-cell"
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

// const debug = "FieldEventStatus_TableCell"
const debug = false

export default class FieldEventStatus_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get canEdit():boolean {
        if (this.props.manager.isReadOnly) return false
        return this.props.field.canEdit(this.props.listItem.item)
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onOptionClick = (option:any, e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        debug && console.log(debug, "onOptionClick", option)

        this.props.listItem.event.isAccomplished = option.value
        this.props.listItem.event.save()

        this.hidePopover()

        if (this.props.onChange) this.props.onChange(option.value)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    renderValue() {
        const status = this.props.field._getOption(this.props.listItem.event.isAccomplished)

        return (
            <div className={Classes('ui5-status-list', 'status-c{0}'.f(status.color), this.props.className)}>
                <div className="max-w-100-percent txt-truncate">{status?.label}</div>
            </div>
        )
    }

    renderHovered() {
        return (
            <div className="cell-flex is-hovered" style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent" onClick={this.onClick}>

                    {this.renderValue()}

                    <div className="buttons flex-no-shrink">
                        <div className="btn-arrow"/>
                    </div>
                </div>

                {this.state.showPopover &&
                    <this.props.field.components.PopoverMenu {...this.props} parent={this}/>}
            </div>
        )
    }

    renderNotHovered() {
        return (
            <div className="cell-flex border-1px-transparent" style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter}
                 onMouseLeave={this.onMouseLeave}>
                {this.renderValue()}
            </div>
        )
    }

    render() {
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered)   return this.renderHovered()
        else                        return this.renderNotHovered()
    }
}



